import React from 'react';
import { Edit, useRecordContext } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import SessionDetailForm from './SessionDetailForm';
import roles from '../../../constants/roles';

const styles = {
  root: {
    padding: '0px',
  },
  card: {
    background: 'none',
    boxShadow: 'none',
    padding: '0px',
  },
};

// Wrapper component to provide record from context to class component
const SessionDetailFormWrapper = ({ permissions }) => {
  const record = useRecordContext();
  return <SessionDetailForm permissions={permissions} record={record} />;
};

const SessionDetail = (props) => {
  const { permissions } = props;
  const navigate = useNavigate();

  if (permissions && permissions !== roles.superAdmin) {
    navigate('/');
  }

  return (
    <Edit {...props}>
      <SessionDetailFormWrapper permissions={permissions} />
    </Edit>
  );
};

export default withStyles(styles)(SessionDetail);
